import { ConfirmSheetProps } from './ConfirmSheet.interface';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { Button, Input } from '$uikit';
import './ConfirmSheet.sass';
import { useTranslator } from '$hooks';

export const ConfirmSheet = (props: ConfirmSheetProps) => {
  const t = useTranslator();
  const { onSubmit, onClose, description, title, mode, isOpened, buttonTitle } = props;

  function renderContent() {
    if (mode === 'input') {
      const { placeholder, onChange, value } = props;

      return (
        <Input
          placeholder={placeholder}
          onChange={(e) => {
            onChange((e.target as HTMLInputElement).value);
          }}
          value={value}
        />
      );
    }

    return null;
  }

  if (!isOpened) {
    return null;
  }

  return (
    <BottomSheet title={title} onClose={onClose} className="ConfirmSheet">
      <div className="ConfirmSheet__description">{description}</div>
      {renderContent()}
      <Button onClick={() => onSubmit(true)} className="ConfirmSheet__confirm__button">
        {buttonTitle || t('confirm_code_confirmation_button')}
      </Button>
    </BottomSheet>
  );
};
